import { FASTElement } from "@microsoft/fast-element";
/**
 * TableCell
 * @summary TableCell defines a customizable table cell element within a table structure.
 *
 * @example
 * ```html
 * <fabric-table-cell size="medium">
 *   <div slot="before">Before content</div>
 *   Main content
 *   <div slot="after">After content</div>
 * </fabric-table-cell>
 * ```
 *
 * @attr {TableCellSize} size - The size of the table cell. Possible values are 'small', 'medium', 'large'.
 *
 * @prop {TableCellSize} size - The size of the table cell. Possible values are 'small', 'medium', 'large'.
 *
 * @slot before - Slot for content to be inserted before the main content.
 * @slot default - The default slot for the main content of the table cell.
 * @slot after - Slot for content to be inserted after the main content.
 *
 * @csspart table-cell - The main wrapper part of the table cell.
 * @csspart cell-content - The content part of the table cell, acting as a container for slotted elements.
 *
 * @method connectedCallback - Called when the element is connected to the DOM.
 * @method disconnectedCallback - Called when the element is disconnected from the DOM.
 *
 * @extends FASTElement
 * @tagname fabric-table-cell
 * @public
 */
export class TableCell extends FASTElement {
    /**
     * Called when the element is connected to the DOM.
     * @public
     */
    connectedCallback() {
        super.connectedCallback();
    }
    /**
     * Called when the element is disconnected to the DOM.
     * @public
     */
    disconnectedCallback() {
        super.disconnectedCallback();
    }
}
//# sourceMappingURL=table-cell.js.map